/**
 * Authentication constants for token-based authentication
 * Used by useTokenAuthentication hook and auth-related components
 */

export const STEP_STATUS = Object.freeze({
  idle: 'idle',
  inProgress: 'in_progress',
  success: 'success',
  failed: 'failed',
});

export const AUTH_ERROR_TYPES = Object.freeze({
  INVALID_TOKEN: 'invalid_token',
  EXPIRED_TOKEN: 'expired_token',
  MISSING_TOKEN: 'missing_token',
});
